import PolicyShowPage from "~/pages/insurance/policy_show/PolicyShowPage.vue";
import PolicyEditPage from "~/pages/insurance/policy_edit/PolicyEditPage.vue";
import PolicyCreatePage from "~/pages/insurance/policy_create/PolicyCreatePage.vue";
import InsurancePage from "~/pages/insurance/index/InsurancePage.vue";
import PackageCreateOrEditPage from "~/pages/insurance/package_create_or_edit/PackageCreateOrEditPage.vue";

export default [
  {
    path: "",
    component: InsurancePage,
    name: "index",
    meta: {
      storesToReset: ["$_policy_page"],
    },
  },
  {
    path: "/policy/:policy",
    component: PolicyShowPage,
    name: "policy",
    meta: {
      storesToReset: ["$_policy_show"],
    },
  },
  {
    path: "/package/:policy",
    component: PolicyShowPage,
    name: "package",
    meta: {
      storesToReset: ["$_policy_show"],
    },
  },
  {
    path: "/createSingle/policy",
    component: PolicyCreatePage,
    name: "policy.createSingle",
    meta: {
      storesToReset: ["$_generic_insurance"],
    },
  },
  {
    path: "/package/:package/create/policy",
    component: PolicyCreatePage,
    name: "policy.create",
    meta: {
      storesToReset: ["$_generic_insurance"],
    },
  },
  {
    path: "/create/package",
    component: PackageCreateOrEditPage,
    name: "createPackage",
    meta: {
      storesToReset: ["$_generic_insurance", "$_package_create_or_edit"],
    },
  },
  {
    path: "/package/:package/edit",
    component: PackageCreateOrEditPage,
    name: "package.edit",
    meta: {
      storesToReset: ["$_generic_insurance", "$_package_create_or_edit"],
    },
  },
  {
    path: "/package/:package/edit/:policy",
    component: PolicyEditPage,
    name: "policy.edit",
    meta: {
      storesToReset: ["$_generic_insurance", "$_policy_edit"],
    },
  },
  {
    path: "/edit/:policy",
    component: PolicyEditPage,
    name: "policy.edit_single",
    meta: {
      storesToReset: ["$_generic_insurance", "$_policy_edit"],
    },
  },
];
